export default "__VITE_ASSET__BKzf232Z__"